var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 7a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm-7-7a9.5 9.5 0 0 1 8.46 5.174A11.053 11.053 0 0 0 16 5C9.925 5 5 9.925 5 16c0 .669.06 1.324.174 1.96A9.5 9.5 0 0 1 9.5 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/union.13bb7b9d3d621444abca2847b3c8bb7f.svg";